import { useCallback } from "react";
import { useWorkspacesSelector } from "../store";
export const useAllWorkspacesSelector = (selector) => {
    const memoizedSelector = useCallback((state) => {
        if (selector !== undefined) {
            return selector(state);
        }
        return state;
    }, [selector]);
    return useWorkspacesSelector((s) => memoizedSelector(s.workspacesModule));
};
